import { useEffect, useEffectEvent, useState } from 'react'
import { Input } from '../ui/input'
import styles from './FilterBar.module.css'

export const FILTER_DELAY = 300

export type DebouncedInputProps = {
  id: string
  label: string
  value: string
  placeholder: string
  type?: 'search' | 'text'
  onCommit: (value: string) => void
}

export function DebouncedInput({
  id,
  label,
  value,
  placeholder,
  type = 'text',
  onCommit,
}: DebouncedInputProps) {
  const [draft, setDraft] = useState(value)
  const [seen, setSeen] = useState(value)
  const [sent, setSent] = useState(value)

  if (value !== seen) {
    setSeen(value)

    if (value !== sent) setDraft(value)
  }

  const commit = useEffectEvent((next: string) => {
    setSent(next)
    onCommit(next)
  })

  useEffect(() => {
    if (draft === value) return

    const timer = setTimeout(() => commit(draft), FILTER_DELAY)

    return () => clearTimeout(timer)
  }, [draft, value])

  return (
    <div className={`${styles.field} ${type === 'search' ? styles.search : ''}`}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <Input
        id={id}
        type={type}
        value={draft}
        placeholder={placeholder}
        onChange={(event) => setDraft(event.target.value)}
      />
    </div>
  )
}
